/* eslint-disable camelcase */
import Socket, { Message } from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { getShowSessions } from '../stores/actions/session';
import { updateCustomBroadcastEndpoint, updateUseCustomBroadcastEndpoint } from '../stores/actions/broadcasting';
import { GreenroomState } from '../stores/types/types';

function handleShowSessionsUpdate(message: any) {
	if (message
		&& message.message
		&& message.message.token
		&& message.message.meeting) {
		socketListenerDispatch(getShowSessions(message.token, message.message.meeting));
	}
}

function handleSettingsQueue(message: any) {
	const { SessionReducer: { session } } = getState() as GreenroomState;
	const { action, from } = message.message;

	if (from !== session) {
		socketListenerDispatch({ ...action, remote: true });
	}
}

function handleCustomEndpointOn({ message }: Message) {
	const {
		SessionReducer: {
			token,
			meeting,
			session,
		},
		HomeReducer: {
			homeMeeting,
		},
		BroadcastReducer: {
			customEndpoint,
			useCustomEndpoint,
		},
	} = getState() as GreenroomState;

	const {
		from,
		name,
		url,
		stream_key,
	} = message;

	if (from === session) return;

	const currentMeeting = meeting || homeMeeting;
	const isNew = JSON.stringify(customEndpoint) !== JSON.stringify({ name, url, stream_key });

	if (currentMeeting && (isNew || !useCustomEndpoint)) {
		socketListenerDispatch(updateCustomBroadcastEndpoint(
			token!,
			currentMeeting.meeting,
			name,
			url,
			stream_key,
		));
	}
}

function handleCustomEndpointOff({ message }: Message) {
	const {
		SessionReducer: {
			token,
			meeting,
			session,
		},
		HomeReducer: {
			homeMeeting,
		},
		BroadcastReducer: {
			useCustomEndpoint,
		},
	} = getState() as GreenroomState;

	const { from } = message;

	if (from === session) return;

	const currentMeeting = meeting || homeMeeting;

	if (currentMeeting && useCustomEndpoint) {
		socketListenerDispatch(updateUseCustomBroadcastEndpoint(token!, currentMeeting.meeting, false));
	}
}

export default function HostSync(socket: Socket) {
	socket.addListener('show-sessions-update', handleShowSessionsUpdate);
	socket.addListener('settings-sync', handleSettingsQueue);
	socket.addListener('custom-endpoint-on-sync', handleCustomEndpointOn);
	socket.addListener('custom-endpoint-off-sync', handleCustomEndpointOff);
}
